import { IPaymentPrefill } from "@rentiohq/shared-frontend/dist/forms/createPayment/schema.createPayment.types";
import { getAmountWithVat } from "@rentiohq/shared-frontend/dist/utils/number.utils";

// One payment a cost payment creates: who pays, for which unit, how much and
// under which description.
export interface ICostPaymentRecapRow {
  payerName?: string;
  unitLabel?: string;
  amountExcl: number;
  vatPct: number;
  amountIncl: number;
  description?: string;
}

// The VAT percentage of a prefill; a "no VAT" reason counts as 0%.
const toVatPct = (vatPct: IPaymentPrefill["vatPct"]): number =>
  typeof vatPct === "number" ? vatPct : 0;

// What a cost payment will bill, one row per payment order: one per split
// when the cost is split over several tenants, else the single payment.
// Amounts incl. VAT are rounded the way the payment form rounds them.
export const getCostPaymentRecapRows = (params: {
  prefill: IPaymentPrefill;
  payerNameOf: (accountId?: number) => string | undefined;
}): ICostPaymentRecapRow[] => {
  const { prefill, payerNameOf } = params;
  if (!prefill.costPayment) return [];
  const vatPct = toVatPct(prefill.vatPct);
  const toRow = (row: {
    amount: number;
    payerId?: number;
    payerName?: string;
    unitLabel?: string;
    description?: string;
  }): ICostPaymentRecapRow => ({
    payerName: row.payerName ?? payerNameOf(row.payerId),
    unitLabel: row.unitLabel,
    amountExcl: row.amount,
    vatPct,
    amountIncl: getAmountWithVat(row.amount, vatPct / 100),
    description: row.description ?? prefill.description,
  });

  const costSplits = prefill.costSplits ?? [];
  if (costSplits.length > 1) {
    return costSplits.map(split => toRow(split));
  }
  if (prefill.amount == null) return [];
  return [
    toRow({
      amount: prefill.amount,
      payerId: prefill.payerId,
      payerName: prefill.payerName,
    }),
  ];
};
